
import React from 'react';
import { BillFormat } from "./BillFormat";

export const InvoiceChallan = React.forwardRef((props, ref) => {
    const { billDetails } = props;
    return (
        <>
            
            {
                billDetails && billDetails?.map((data, i) => (
                    <BillFormat ref={ref} {...props} details={data} keyVal={i} preview={false} />
                ))
            }
        </>
    )
})